/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import styled from 'styled-components';
import { reduxConnect } from '../../common';
import { AnimatedLoadingPlaceholder } from '../common/animatedLoadingPlaceholder/animatedLoadingPlaceholder';
import { IStoreState } from '../common/interfaces/types';
import { isDataError } from '../common/utilities/isDataError';
import { HurricaneMapWrapper } from './hurricaneMapWrapper';
import { CommonHurricaneWidgetUIProps } from './types';
import { HurricaneWidgetErrorUI } from './errorUI/hurricaneWidgetErrorUI';

interface HurricaneWidgetMapUIProps extends Partial<CommonHurricaneWidgetUIProps> {
    isHUrricaneWidgetMap: boolean;
    lastError: Record<string, unknown>;
    requestError: Record<string, unknown>;
    isNoHurricanes: boolean;
    isActiveHurricaneData: boolean;
    widgetIsLazyLoaded: boolean;
}

const mapStoreStateToProps = (storeState: IStoreState) => {
    const { hurricane, hurricaneOutlookSummary } = storeState || {};

    const { hurricaneIsFetching, currentHurricane, currentTrackPoint, lastError, hurricanes } = hurricane || {};
    const { requestError, data } = hurricaneOutlookSummary || {};
    const isNoHurricanes = hurricanes?.length === 0 ;

    return {
        requestError,
        lastError,
        isNoHurricanes,
        isActiveHurricaneData: !!currentHurricane?.id && !!currentHurricane?.type
    };
};

const mapDispatchToProps = {};

export const HurricaneWidgetMapView = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(({ 
    isHUrricaneWidgetMap,
    lastError,
    requestError,
    isNoHurricanes,
    isActiveHurricaneData,
    widgetIsLazyLoaded,
    isLoading, 
    hurricaneOutlookSummaryData, 
    activeHurricaneData }: HurricaneWidgetMapUIProps) => {
    
    const isHurricaneDataError = isDataError(lastError);
    const isHurricanSummaryDataError = isDataError(requestError);
    const isNoHurricaneSummaryData = !hurricaneOutlookSummaryData?.o?.dc;
    // eslint-disable-next-line no-extra-parens
    const shouldDisplayErrorUI: boolean = (isNoHurricanes && isHurricanSummaryDataError) || (isNoHurricaneSummaryData && isHurricaneDataError) || (isHurricanSummaryDataError && isHurricaneDataError);
    
    let mapWrapper = <HurricaneMapWrapper isHUrricaneWidgetMap={isHUrricaneWidgetMap} widgetIsLazyLoaded={widgetIsLazyLoaded} />; // default Hurricane Map UI

    if (isLoading) {
        mapWrapper = <AnimatedLoadingPlaceholder height='100%' radius={1} />;
    }

    if (hurricaneOutlookSummaryData?.o?.dc && !activeHurricaneData && !isLoading) {
        // Product hasn't decided if we are going handle disturbance rendering so let's render the default map layer for now
        mapWrapper = <HurricaneMapWrapper isHUrricaneWidgetMap={isHUrricaneWidgetMap} widgetIsLazyLoaded={widgetIsLazyLoaded} />;
    }

    if (shouldDisplayErrorUI) {
        mapWrapper = <HurricaneWidgetErrorUI />;
    }

    return (
        <WidgetMapUI isErrorUI={shouldDisplayErrorUI}>
            {mapWrapper}
        </WidgetMapUI>
    );
});

interface WidgetMapUIProps {
    isErrorUI?: boolean;
}

const WidgetMapUI = styled.div<WidgetMapUIProps>`
    width: 100%;
    height: ${({ isErrorUI }) => isErrorUI ? '100%' : 'calc(100% - 44px)'};
`;
